module.exports = __webpack_public_path__ + "img/ooredoo-logo.69761823.svg";